module.exports = __webpack_public_path__ + "static/media/pie_chart_placeholder.ad873df5.svg";